<div class="page-layout carded left-sidenav toolbar-fixed-layout">
    <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
        <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
            <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
        </div>
    </div>
    <div class="toolbar second-level-toolbar justify-between items-center">
        <div *ngIf="canAddDrive" class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
            <label class="component-label">Actions</label>
            <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
                <div class="button-container flex flex-row justify-start items-center">
                    <button mat-button class="orbitax-flat-button" (click)="addDrive()"
                            particleAnalytics
                            analyticsCategory="file-manager-content"
                            analyticsAction="Add-Folder">Add Drive
                    </button>
                </div>
            </div>
        </div>
    </div>
    <mat-sidenav-container>
        <!-- CENTER -->
        <div class="center">
            <!-- CONTENT CARD -->
            <div class="content-card mat-white-bg">

                <div class="content pos-relative m-30 flex flex-col">
                    <div class="keno-grid-container">
                        <particle-virtual-grid [sourceKey]="sourceKey"
                                               [invalidateSubject]="invalidateSubject"
                                               (valueChanged)="onGridCellValueChange($event)">
                        </particle-virtual-grid>
                    </div>
                </div>
            </div>
        </div>
    </mat-sidenav-container>
</div>

